import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

const apiAxios = axios.create({
  headers: {
    'Content-Type': 'application/json'
  }
})

Vue.use(Vuex, apiAxios)
var token_pub = 'fasdfeqrw42345234523234'
export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
    login ({ commit }, payload){
      payload.token_pub = token_pub
      return axios.post('/login_validar', payload).then((result) => {
        return result.data
      })
    },
    recuperarClave ({ commit }, payload){
      payload.token_pub = token_pub
      return axios.post('/login_recuperar', payload).then((result) => {
        return result.data
      })
    },
    registrar ({ commit }, payload){
      payload.token_pub = token_pub
      return axios.post('/login_registro', payload).then((result) => {
        return result.data
      })
    },
    subirArchivo ({ commit }, payload){
      payload.token_pub = token_pub
      payload = convertFormData(payload)
      return axios.post('/login_precarga', payload).then((result) => {
        return result.data
      })
    }
  },
  modules: {
  }
})
function convertFormData(data){
  let formData = new FormData();

  for(var key in data){
    formData.append(key, data[key]);
  }

  return formData;
}
